// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

const sendN2PasswordSuccess = () => ({
   type: actionTypes.SEND_N2_PASSWORD_SET_STEP_SUCCESS
});

const sendN2PasswordError = () => ({
   type: actionTypes.SEND_N2_PASSWORD_SET_STEP_ERROR
});

const resetN2PasswordWizard = () => ({
    type: actionTypes.RESET_SEND_N2_PASSWORD_STEP1
});

const postChange = () => (dispatch) => {

        APIGet(dispatch, apiURLBuilder.getURL('sendN2PasswordByPostMail')).then(
            () =>  {
                dispatch(sendN2PasswordSuccess());
            },
            () => {
                dispatch(sendN2PasswordError());
            }
        );
};

module.exports = {
    postChange,
    resetN2PasswordWizard
}
